// Module
var code = "<a href=\"javascript:;\" class=\"btn print-btn transition subFormControl\"> <i class=\"fa fa-print\"></i> Print </a>";
// Exports
export default code;